<template>
  <div>
    <v-dialog
      v-model="activo"
      max-width="1000"
    >
      <v-card
        flat
      >
        <v-card-title>
          Agregar Periodo de Pago Factura {{ factura_id }}
          <v-spacer></v-spacer>
          <v-btn icon @click="activo = false"><v-icon title="Cerrar">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <!-- Forma de Ingreso de Pago -->
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12">
              <v-switch
                v-model="pagoFormaIngreso"
                class="d-flex align-center py-0 my-0"
                hide-details
                dense
                :label="`Forma de Ingreso: ${pagoNombreForIngreso}`"
              ></v-switch>
            </v-col>
          </v-row>
          <!-- Campos Ingreso Pago -->
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12" sm="2" md="2" class="py-1">
              <FechaPicker
                v-model="filtro.fecha_pago"
                hideDetails
              />
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1">
              <v-text-field
                v-model="filtro.porcentaje"
                outlined
                dense
                hide-details
                type="number"
                suffix="%"
                @blur="validaPorcentaje()"
                label="Porcentaje"
                :disabled="pagoFormaIngreso == true ? true : false"
                :readonly="pagoFormaIngreso == true ? true : false"
                :filled="pagoFormaIngreso == true ? true : false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1">
              <TextFieldMoney 
                v-model="filtro.importe"
                label="Importe"
                v-bind:properties="{ prefix: '$', 'hide-details': boolString == 'true', 'disabled': pagoFormaIngreso == false ? boolString == 'true' : boolString == 'false',
                  'readonly': pagoFormaIngreso == false ? boolString == 'true' : boolString == 'false', 'filled': pagoFormaIngreso == false ? boolString == 'true' : boolString == 'false',
                }"
                @blur="validaImportePago()"
              />
            </v-col>
            <v-col cols="12" sm="3" md="3" class="py-1">
              <v-autocomplete
                v-model="filtro.forma_pago_id"
                item-text="forma_pago_nombre"
                item-value="forma_pago_id"
                :items="formas_pago"
                hide-details
                outlined
                dense
                label="Forma Pago"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1">
              <v-autocomplete
                v-model="filtro.tipo_pago_id"
                item-text="tipo_pago_nombre"
                item-value="tipo_pago_id"
                :items="tipos_pagos"
                hide-details
                outlined
                dense
                label="Tipo Pago"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="1" md="1" class="py-1">
              <v-btn icon color="success" small @click="emitirPago()"><v-icon>fas fa-check</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FechaPicker from '../util/FechaPicker.vue'
import TextFieldMoney from '../util/TextFieldMoney.vue'
import moment from 'moment'
import { cadenaVacia, roundNumber } from '../../util/utils'
export default {
  props: {
    datos: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  components: {
    FechaPicker,
    TextFieldMoney
  },
  computed: {
    activo: {
      get(){
        return this.datos.activo
      },
      set(value){
        this.$emit('setearModalPagos', value)
      }
    },
    factura_id: {
      get(){
        return this.datos.factura_id
      }
    },
    formas_pago: {
      get(){
        return this.datos.formas_pago
      }
    },
    tipos_pagos: {
      get(){
        return this.datos.tipos_pagos
      }
    },
    porcentaje_acumulado: {
      get(){
        return this.datos.porcentaje_acumulado
      }
    },
    total_factura: {
      get(){
        return this.datos.total_factura
      }
    },
    importe_acumulado: {
      get(){
        return this.datos.importe_acumulado
      }
    }
  },
  data() {
    return {
      filtro: {
        fecha_pago: moment(new Date()).format('DD/MM/YYYY'),
        porcentaje: null,
        importe: null,
        forma_pago_id: null,
        tipo_pago_id: null
      },
      boolString: "true",
      pagoFormaIngreso: false,
      pagoNombreForIngreso: 'Porcentaje'
    }
  },
  methods: {
    async validaFechaPago(){
      if (cadenaVacia(this.filtro.fecha_pago) || this.activo == false) return
      this.$store.state.loading = true
      let diaPeticion = await this.$store.dispatch('facturasCompra/validarFecha', {fecha: this.filtro.fecha_pago})
      this.$store.state.loading = false
      if (diaPeticion.resultado == 0){
        this.filtro.fecha_pago = moment(new Date()).format('DD/MM/YYYY')
        this.$store.dispatch('show_snackbar', {
          text: diaPeticion.msj,
          color: 'error',
        })
        return
      }
      if (diaPeticion.feriados.length > 0){
        // tengo feriado el día que me dieron
        this.$store.dispatch('show_snackbar', {
          text: 'No se puede seleccionar la fecha ' + this.filtro.fecha_pago + ' por ser ' + diaPeticion.feriados[0].nombre_feriado,
          color: 'warning',
        })
        // seteo nuevamente la fecha
        this.filtro.fecha_pago = moment(new Date()).format('DD/MM/YYYY')
      }
    },
    validaPorcentaje(){
      if (cadenaVacia(this.filtro.porcentaje) || this.filtro.porcentaje == 0 || this.pagoFormaIngreso == true) return
      let porcentajePago = roundNumber(this.filtro.porcentaje, 6)
      // negativo o mayor a 0?
      if (porcentajePago < 0 || porcentajePago > 100){
        this.$store.dispatch('show_snackbar', {
          text: 'Porcentaje no válido. Debe ser un número entre 1 y 100.',
          color: 'error',
        })
        this.filtro.porcentaje = null
        this.filtro.importe = null
        return
      }
      // obtengo el porcentaje total
      let porcentajeTotal = roundNumber(this.porcentaje_acumulado + porcentajePago, 6)
      if (porcentajeTotal > 100){
        this.$store.dispatch('show_snackbar', {
          text: 'Porcentaje no válido. Excede el total de la Factura.',
          color: 'error',
        })
        this.filtro.porcentaje = null
        this.filtro.importe = null
        return
      }
      // calculo mi importe
      let porcentaje = roundNumber(porcentajePago/100, 6)
      let importePago = roundNumber(porcentaje * this.total_factura, 6)
      // llegué al 100%?
      if (porcentajeTotal == 100){
        let nuevoTotal = roundNumber(importePago + this.importe_acumulado, 6)
        if (nuevoTotal > this.total_factura) importePago = roundNumber(this.total_factura - this.importe_acumulado, 6)
      }
      this.filtro.importe = importePago
    },
    validaImportePago(){
      if (cadenaVacia(this.filtro.importe) || this.filtro.importe == 0 || this.pagoFormaIngreso == false) return
      this.filtro.importe = roundNumber(this.filtro.importe, 6)
      let porcentaje = roundNumber((this.filtro.importe*100)/this.total_factura, 6)
      this.filtro.porcentaje = porcentaje
      let nuevoPorcentaje = roundNumber(porcentaje + this.porcentaje_acumulado, 6)
      if (nuevoPorcentaje > 100) this.filtro.porcentaje = roundNumber(100 - this.porcentaje_acumulado, 6)

    },
    limpiarFiltro(){
      this.filtro = {
        fecha_pago: moment(new Date()).format('DD/MM/YYYY'),
        porcentaje: null,
        importe: null,
        forma_pago_id: null,
        tipo_pago_id: null
      }
    },
    validarForm(){
      if (cadenaVacia(this.filtro.fecha_pago)) return {valido: false, msj: 'Debe ingresar la Fecha de Pago.'}
      if (cadenaVacia(this.filtro.porcentaje) || this.filtro.porcentaje == 0) return {valido: false, msj: 'Debe ingresar un Porcentaje válido.'}
      if (cadenaVacia(this.filtro.importe) || this.filtro.importe == 0) return {valido: false, msj: 'Debe ingresar un Importe válido.'}
      if (cadenaVacia(this.filtro.forma_pago_id)) return {valido: false, msj: 'Debe seleccionar la Formna de Pago.'}
      if (cadenaVacia(this.filtro.tipo_pago_id)) return {valido: false, msj: 'Debe seleccionar el Tipo de Pago.'}
      return {valido: true, msj: 'OK'}
    },
    emitirPago(){
      let valido = this.validarForm()
      if (valido.valido == false){
        this.$store.dispatch('show_snackbar', {
          text: valido.msj,
          color: 'warning',
        })
        return
      }
      let item = {}
      Object.assign(item, this.filtro)
      this.$emit('setPeriodoPago', item)
      this.activo = false
    },
    limpiarForm(){
      this.limpiarFiltro()
      this.pagoFormaIngreso = false,
      this.pagoNombreForIngreso = 'Porcentaje'
    }
  },
  watch: {
    pagoFormaIngreso: function(){
      this.limpiarFiltro()
      if (this.pagoFormaIngreso == false)this.pagoNombreForIngreso = 'Porcentaje'
      else this.pagoNombreForIngreso = 'Importe'
    },
    'filtro.fecha_pago': {
      handler: function(val){
        this.validaFechaPago()
      },
      deep: true
    },
    activo: function(){
      if (this.activo == false) this.limpiarForm()
    }
  },
}
</script>

<style>

</style>